<template>
<div class="wmin-sm-400">
    <div class="card mb-0">
        <div class="card-body">
            <section id="ForgotPassword">
                <div class="text-center mb-3">
                    <img alt :src="$storeIndex.getImageGobalAssets('authorization/logo-goship-gosell')" class='logo-goship-gosell' />
                </div>
                <div class="text-center mb-3">
                    <h3>{{$t('Change password')}}</h3>
                    <div v-if="$route.query.si" class="form-group">
                        <div class="alert alert-sky">
                            <i class="fa fa-info-circle text-size-16 mr-1"></i> {{ $t('Change new password to secure the account') }}
                        </div>
                    </div>
                    <p class="text-muted" v-else>{{$t('Enter and confirm a secure new password for the account.')}} </p>
                </div>
                <div v-if="message" class="form-group">
                    <div class="alert alert-danger">
                        <i class="fa fa-info-circle"></i> {{ $t(message)+' '+limit+' '+$t(times) }}
                    </div>
                </div>
                <div class="form-group form-group-feedback form-group-feedback-left" v-bind:class="{'form-group-error': $v.form.password.$error}">
                    <div 
                        class="popover bs-popover-right valid-password"
                        v-if="
                            $v.form.password.required && !$v.form.password.minLength && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.maxLength && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.continuously && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.uppercase && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.lowercase && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.number && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.special && referCode.length == 0 
                        "
                    >
                        <div class="arrow valid-arrow"></div>
                        <div class="popover-body text-size-13">
                            <div class="d-flex">
                                <i class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13" v-if="!$v.form.password.minLength"></i>
                                <i class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13" v-else></i>
                                {{$t('Password must have at least') + ' ' + $v.form.password.$params.minLength.min + ' ' + $t('digits.')}}
                            </div>
                            <div class="d-flex">
                                <i class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13" v-if="!$v.form.password.maxLength"></i>
                                <i class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13" v-else></i>
                                {{$t('Password must have at most') + ' ' + $v.form.password.$params.maxLength.max + ' ' + $t('digits.')}}
                            </div>
                            <div class="d-flex">
                                <i class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13" v-if="!$v.form.password.continuously"></i>
                                <i class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13" v-else></i>
                                {{$t('Consecutive letters or numbers cannot be used')}}
                            </div>
                            <div class="d-flex">
                                <i class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13" v-if="!$v.form.password.uppercase"></i>
                                <i class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13" v-else></i>
                                {{$t('At least 1 uppercase letter')}}
                            </div>
                            <div class="d-flex">
                                <i class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13" v-if="!$v.form.password.lowercase"></i>
                                <i class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13" v-else></i>
                                {{$t('At least 1 lowercase letter')}}
                            </div>
                            <div class="d-flex">
                                <i class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13" v-if="!$v.form.password.number"></i>
                                <i class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13" v-else></i>
                                {{$t('At least 1 number')}}
                            </div>
                            <div class="d-flex">
                                <i class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13" v-if="!$v.form.password.special"></i>
                                <i class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13" v-else></i>
                                {{$t('At least 3 special characters')}}
                            </div>
                        </div>
                    </div>
                    <input :type="showPasswordType" 
                    :class="['form-control' ,
                        $v.form.password.required && referCode.length == 0 ? 
                            !$v.form.password.minLength ||
                            !$v.form.password.maxLength ||
                            !$v.form.password.continuously ||
                            !$v.form.password.uppercase ||
                            !$v.form.password.lowercase ||
                            !$v.form.password.number ||
                            !$v.form.password.special ?
                                'border-danger' : 'border-success' 
                            : ''
                    ]"
                    :placeholder="$t('New Password')" 
                    v-model.trim.lazy="$v.form.password.$model" 
                    v-on:keyup="realtime($event,'password')"
                    />
                    <div class="form-control-feedback">
                        <i class="far fa-user-lock text-muted"></i>
                    </div>
                    <div v-if="
                            $v.form.password.required && !$v.form.password.minLength && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.maxLength && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.continuously && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.uppercase && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.lowercase && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.number && referCode.length == 0 ||
                            $v.form.password.required && !$v.form.password.special && referCode.length == 0 
                        "
                    class="form-control-feedback text-danger icon-mark-2">
                        <i class="icon-cancel-circle2"></i>
                    </div>
                    <div v-else-if="$v.form.password.required && referCode.length == 0" class="form-control-feedback text-success icon-mark-2">
                        <i class="icon-checkmark-circle"></i>
                    </div>
                    <span class="form-control-feedback icon-mark-1">
                        <a class="cursor-pointer" @click="showPassword"><i :class="iconShowPassword"></i></a>
                    </span>
                    <div v-if="!$v.form.password.required" class="validation-invalid-label">{{$t('Please enter password.')}}</div>
                    <div v-else-if="!$v.form.password.minLength && referCode.length != 0" class="validation-invalid-label">
                        {{ $t("Password must have at least") + " " + $v.form.password.$params.minLength.min + " " + $t("digits.") }}
                    </div>
                    <div v-else-if="!$v.form.password.maxLength && referCode.length != 0" class="validation-invalid-label">
                        {{ $t("Password must have at most") + " " + $v.form.password.$params.maxLength.max + " " + $t("digits.") }}
                    </div>
                </div>
                <div class="form-group form-group-feedback form-group-feedback-left" v-bind:class="{'form-group-error': $v.form.repeatPassword.$error}">
                    <input :type="showConfirmPasswordType" 
                    :class="['form-control' ,
                        $v.form.repeatPassword.required && referCode.length == 0 ? 
                            !$v.form.repeatPassword.sameAsPassword ?
                                'border-danger' : 'border-success' 
                            : ''
                    ]"
                    :placeholder="$t('Confirm New Password')" 
                    v-model.trim="$v.form.repeatPassword.$model" 
                    v-on:keyup="realtime($event,'repeatPassword')"
                    />
                    <div class="form-control-feedback">
                        <i class="far fa-user-lock text-muted"></i>
                    </div>
                    <div v-if="$v.form.repeatPassword.required && !$v.form.repeatPassword.sameAsPassword && referCode.length == 0" class="form-control-feedback text-danger icon-mark-2">
                        <i class="icon-cancel-circle2"></i>
                    </div>
                    <div v-else-if="$v.form.repeatPassword.required && referCode.length == 0" class="form-control-feedback text-success icon-mark-2">
                        <i class="icon-checkmark-circle"></i>
                    </div>
                    <span class="form-control-feedback icon-mark-1">
                        <a class="cursor-pointer" @click="showConfirmPassword"><i :class="iconConfirmShowPassword"></i></a>
                    </span>
                    <div v-if="!$v.form.repeatPassword.required" class="validation-invalid-label">{{$t('Please enter confirm new password.')}}</div>
                    <div v-else-if="!$v.form.repeatPassword.sameAsPassword && referCode.length != 0" class="validation-invalid-label">{{$t('Confirm New Passwords must be the same as "Password".')}}</div>
                </div>
                <div class="form-group" id="generate">
                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <button type="button" class="col-12 btn btn-outline bg-slate-600 text-slate-600 border-slate-600" @click="generatePassword(8)"><i class="fa-solid fa-arrows-rotate mr-1"></i>{{ $t("_Password.Generate Password") }}</button>
                        </div>
                        <div class="col-12 col-sm-6">
                            <button type="button" class="col-12 btn btn-outline bg-slate-600 text-slate-600 border-slate-600" v-clipboard:copy="genPasswordCopy" v-clipboard:success="copySuccess"><i class="fa-regular fa-copy mr-1"></i>{{ $t('Copy') }}</button>
                        </div>
                    </div>
                </div>
                <div class="form-group" id="btnReset">
                    <ladda text="Reset Password" :disabled="$v.validationGroup.$invalid" :btnClass="'btn btn-primary btn-block'" :loading="loading" @click="goChangePassword()"></ladda>
                </div>

                <div>
                    <div class="form-group mb-0">
                        <div class="btn-group-justified">
                            <ul class="m-auto navbar-nav" style="width: 125px">
                                <li class="nav-item dropdown language-switch">
                                    <a
                                        class="navbar-nav-link dropdown-toggle"
                                        data-toggle="dropdown"
                                    >
                                        <img
                                            :src="
                                                $storeIndex.getImageSrc('lang/' + lang)
                                            "
                                            class="img-flag mr-2"
                                            alt=""
                                        />
                                        {{ $t(title) }}
                                    </a>
                                    <div class="dropdown-menu">
                                        <a
                                            v-for="(value, key) in localList"
                                            :name="key"
                                            :key="`lang-${key}`"
                                            @click="selectLang(key)"
                                            href="javascript:void(0);"
                                            class="dropdown-item english"
                                        >
                                            <img
                                                :src="
                                                    $storeIndex.getImageSrc(
                                                        'lang/' + key
                                                    )
                                                "
                                                class="img-flag"
                                                alt=""
                                            />
                                            {{ $t(value) }}
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
</template>

<script>
import CentralApi from '@/services/endpoint/central.service'
import {
    required,
    minLength,
    maxLength,
    sameAs,
    email,
    numeric
} from "vuelidate/lib/validators";
import {
    helpers
} from 'vuelidate/lib/validators'
import Ladda from '@/plugins/Ladda.vue'
import { localSave, localRead } from "@/store/lang";


export default {
    components: {
        Ladda
    },
    data() {
        return {
            lang: localRead("local"),
            localList: {
                th: "Thai",
                en: "English",
            },
            message:'',
            limit: '',
            times: '',
            loading: false,
            form: {
                password: '',
                repeatPassword: '',
            },
            showPasswordType: 'password',
            iconShowPassword: 'far fa-eye-slash',
            showConfirmPasswordType: 'password',
            iconConfirmShowPassword: 'far fa-eye-slash',
            referCode: [],
        };
    },
    async created() {
        // promotion_item_coupon_id
        if(this.$route.query.si || this.$route.query.ref) {
            let findRef = this.$route.query.si ? atob(this.$route.query.si) : atob(this.$route.query.ref);
            let refer = await CentralApi.Auth.hasReferbyByEmail(findRef);
            if (refer.data) {
                this.referCode = refer.data;
            }
        }
    },
    computed: {
        title() {
            return this.localList[this.lang];
        },
    },
    validationConfig: {
        $lazy: true,
    },
    validations: {
        form: {
            password: {
                required,
                uppercase: function(value) {
                    if(this.referCode.length != 0) return true;
                    return /[A-Z]{1}/.test(value);
                },
                lowercase: function(value) {
                    if(this.referCode.length != 0) return true;
                    return /[a-z]{1}/.test(value);
                },
                number: function(value) {
                    if(this.referCode.length != 0) return true;
                    return /[0-9]{1}/.test(value);
                },
                special: function(value) {
                    if(this.referCode.length != 0) return true;
                    if(value.length > 0) {
                        var regex = /^[A-Za-z0-9 ]+$/;
                        for(let special=0,i=0;i<value.length;i++) {
                            if(!regex.test(value[i])) {
                                special++;
                            }
                            if(value.length == (i+1)) {
                                if(special >= 3) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        }
                    } else {
                        return false;
                    }
                },
                continuously: function(value) {
                    if(this.referCode.length != 0) return true;
                    if(value.length > 0) {
                        for(let i=0;i<value.length;i++) {
                            if(i>0 && value[i-1] == value[i]) {
                                return false;
                            } else if(value.length == (i+1)) {
                                return true;
                            }
                        }
                    } else {
                        return true;
                    }
                },
                minLength: minLength(8),
                maxLength: maxLength(16)
            },
            repeatPassword: {
                required,
                sameAsPassword: sameAs("password")
            },
        },
        validationGroup: ['form.password', 'form.repeatPassword']
    },
    methods: {
        genPasswordCopy() {
            return this.$v.form.repeatPassword.$model;
        },
        copySuccess(e) {
            this.$toastr.Add({
                type: "success",
                title: "<span class='t-icon icon-checkmark3'></span>"+this.$t('Success'),
                msg: this.$t('Copy password success.'),
                clickClose: true,
                timeout: 2000,
                position: "toast-top-right"
            });
            this.showPasswordType = "password";
            this.iconShowPassword = "far fa-eye-slash";
            this.showConfirmPasswordType = "password";
            this.iconConfirmShowPassword = "far fa-eye-slash";
        },
        generatePassword(quantity) {
            let strText = [
                "!@#$%^&*",                     // special
                "ABCDEFGHIJKLMNOPQRSTUVWXYZ",   // uppercase
                "abcdefghijklmnopqrstuvwxyz",   // lowercase
                "1234567890"                    // number
            ];
            let strLength = [3,1,1,1,quantity - 6];
            let ramdomArray = [];
            strLength.forEach(function callback(value, index) {
                while(value > 0) {
                    let numberIndex = index == 4 ? Math.floor(Math.random() * (3 - 1 + 1) + 1) : index;
                    ramdomArray.push(strText[numberIndex].substr(Math.floor(strText[numberIndex].length*Math.random()), 1));
                    if(index == 0 || index == 4) {
                        ramdomArray = ramdomArray.filter((item, i, ar) => ar.indexOf(item) === i);
                        if(index == 0 && ramdomArray.length == 3 || index == 4 && ramdomArray.length == quantity){
                            value = 0;
                        }
                    } else {
                        value = value - 1;
                    }
                }
            });
            this.$v.form.password.$model = ramdomArray.sort(()=>Math.random()-.5).join('');
            this.$v.form.repeatPassword.$model = this.$v.form.password.$model;
            this.showPasswordType = "text";
            this.iconShowPassword = "far fa-eye";
        },
        selectLang(lang) {
            localSave("local", lang);
            location.reload();
        },
        realtime: function(event,key){
            this.$v.form[key].$model = event.target.value;
        },
        async goChangePassword() {
            if(this.$v.validationGroup.$invalid == true) {
                $('#btnReset button.btn.btn-ladda.btn-ladda-spinner.ladda-button.btn.btn-primary').attr('disabled', this.$v.validationGroup.$invalid);
                return;
            }
            if(this.$v.validationGroup.$invalid == false){
                this.loading = true;
                let data = {
                    password: this.$v.form.password.$model,
                    password_confirmation: this.$v.form.repeatPassword.$model,
                    user_email: this.$route.query.v,
                }
                await CentralApi.Auth.resetPassword(data).then((res) => {
                    let emailAdress = res.data.email;
                    this.logOut();
                    // this.$router.push({name:'auth.successpassword', params:{email:emailAdress}});
                },
                error => {
                    this.message = error.response.data.message;
                    this.limit = error.response.data.limit? error.response.data.limit : '';
                    this.times = error.response.data.times? error.response.data.times : '';
                    this.loading = false;
                });
            }
        },
        async showPassword() {
            this.showPasswordType = this.showPasswordType === 'password' ? 'text': 'password';
            this.iconShowPassword = this.iconShowPassword === 'far fa-eye-slash'? 'far fa-eye': 'far fa-eye-slash';
        },
        async showConfirmPassword() {
            this.showConfirmPasswordType = this.showConfirmPasswordType === 'password' ? 'text': 'password';
            this.iconConfirmShowPassword = this.iconConfirmShowPassword === 'far fa-eye-slash'? 'far fa-eye': 'far fa-eye-slash';
        },
        logOut: async function () {
            
            // await Api.Tenant.logOut();
            await CentralApi.Auth.logOut();
            if(this.$cookie.get('tenantToken')) {
                
                this.$cookie.remove('tenantToken', { domain: '.' + process.env.CENTRAL_API_ROOT });
            }
            this.$cookie.remove('centralToken', { domain: '.' + process.env.CENTRAL_API_ROOT });
            window.location.href = process.env.CENTRAL_API_ROOT + '/login'
        },
    },
    mounted() {
    }
};
</script>

<style scoped>
    input[type="email"],
    input[type="text"],
    input[type="password"] {
        font-family: 'Sarabun', sans-serif;
    }

    div.validation-invalid-label {
        display: none !important;
    }

    div.form-group-error>div.validation-invalid-label {
        display: block !important;
    }

    .alert-sky {
        padding: 7px !important;
        background-color: #2196F31F !important;
        color: #2196F3 !important;
        font-size: 13px;
    }

    .text-size-13 {
        font-size: 13px !important;
    }

    .text-size-16 {
        font-size: 16px !important;
    }

    #generate .btn.btn-outline:hover {
        color: #333 !important;
        background-color: #fafafa;
        border-color: #ddd;
    }

    .icon-mark-1 {
        left: auto;
        right: 0px;
        font-size: 13px;
    }

    .icon-mark-2 {
        left: auto;
        right: 22px;
        margin-top: -0.7%;
    }

    .valid-password {
        display: block;
        margin: 0px;
        max-width: 100% !important;
        width: max-content !important;
        bottom: 42px;
        top: auto;
        right: auto;
        left: 355px;
        bottom: -64px;
        z-index: 101;
    }

    .valid-arrow {
        top: 50%;
        margin-top: -2.5px;
    }

    @media only screen and (max-width: 881px) {
        .valid-password {
            top: auto;
            right: auto;
            left: auto;
            bottom: 45px;
            max-width: 100% !important;
        }
        .valid-arrow {
            top: auto;
            margin-top: 0px;
            left: 45%;
            margin-left: -2.5px;
        }
        .bs-popover-auto[x-placement^=right]>.arrow, .bs-popover-right>.arrow {
            bottom: calc((0.375rem + 1px) * -1);
            width: 0.75rem;
            height: 0.375rem;
            margin: 0 0.25rem;
        }
        .bs-popover-auto[x-placement^=right]>.arrow::before, .bs-popover-right>.arrow::before {
            bottom: 0;
            border-width: 0.375rem 0.375rem 0;
            border-top-color: rgba(0,0,0,.2);
            left: 10%;
            border-right-color: rgb(0 0 0 / 0%);
        }
        .bs-popover-auto[x-placement^=right]>.arrow::after, .bs-popover-right>.arrow::after {
            bottom: 1px;
            border-width: 0.375rem 0.375rem 0;
            border-top-color: #fff;
            border-right-color: rgb(0 0 0 / 0%);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/central/account/profile/ChangePassword.vue